<template>
	<div>
		<PersonalBanner />

		<div class="content-zsy">
			<div class="title-wrap">
				<h3>시작하기</h3>
				<h4>중국직구가 처음이세요?</h4>
				<div class="summary">고로켓고에서 방법을 알려드릴게요 시작해보세요</div>
			</div>
			<el-row>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							1. 가입 및 구매
							<img loading="lazy" src="../../assets/icon/flag_cn.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								알리바바 그룹은 전세계 굴지의 인터넷기업이며 <br class="visible-lg">
								온라인 전자상거래 플랫폼인 타오바오 TMALL 1688등 <br class="visible-lg">
								다양한 온라인 시장을 보유하고 있습니다.<br>
								타오바오 계정은 타오바오 TMALL 1688계정을 공유합니다.<br>
								타오바오 기준으로 안내드릴게요.<br>
								PC 혹은 스마트폰 구글 스토어에서 타오바오 앱 설치 후 가입하세요.
							</p>
							<div class="img-box mb20 ">
								<img loading="lazy"  v-if="!isMobile" src="../../assets/list/document_start_img1.png" alt=""  class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img1_2x.png" alt=""  class="img-responsive" >
							</div>
							<div class="btn-wrap">
								<div class="link-btn type-1" @click="goCustomsinfoUrl('https://blog.naver.com/postteam')">
										PC가입방법 <i class="el-icon-top-right"></i>
								</div>
								<div class="link-btn type-2" @click="goCustomsinfoUrl('https://blog.naver.com/postteam')">
										앱 가입방법 <i class="el-icon-top-right"></i>
								</div>
							</div>
							<div class="divided-line"></div>
							<p class="mb20">
								상품 검색 후 구입을 합니다.<br>
								사이트에서 중국 내 택배수령주소는 반드시 고로켓고 <br>
								중국주소로 해주세요.
							</p>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img2_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img2.png" alt=""  class="img-responsive" >
							</div>
							<div class="btn-wrap">
								<div class="link-btn type-2" @click="goCustomsinfoUrl('https://blog.naver.com/postteam/223133013606')">
									구입방법 <i class="el-icon-top-right"></i>
								</div>
								<div class="link-btn type-2" @click="onNav('/')">
									설정방법 <i class="el-icon-top-right"></i>
								</div>
							</div>
							
						</div>
						
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							2. 배송 신청서 작성
							<!-- <img loading="lazy" src="../../assets/icon/ico_packing.png" alt="" class=""> -->
						</div>
						<div class="card-body">
							<p class="mb60 mb40-xs">
								상품 구입을 하셨다면 바로 배송신청서를 작성해주세요.<br>
								상품 구입 후 1~2일 지나면 판매자가 <br>
								중국택배송장을 타오바오에 업로드합니다.<br>
								고로켓고 마이페이지 신청서에 택배송장번호를 입력해주세요.
							</p>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img3_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img3.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb40-zsy">
							</p>
							<p class="mb60 mb40-xs">
								고로켓고에서는 도착하는 모든 상품의 택배송장번호를 스캔 후 <br>
								상품을 각 회원님에게 맞는 보관/검수/포장을 해요.
							</p>
							<div class="btn-wrap">
								<div class="link-btn type-2" @click="goCustomsinfoUrl('https://blog.naver.com/postteam/223485573208')">
									배송신청서 작성 방법 <i class="el-icon-top-right"></i>
								</div>
							</div>			
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							3. 검수포장
							<!-- <img loading="lazy" src="../../assets/icon/ico_packing.png" alt="" class=""> -->
						</div>
						<div class="card-body">
							<p class="mb20">
								택배송장번호를 잘 입력하셨다면 <br>
								구입하신 상품이 고로켓고에 도착하면 작성하신 <br >
								배송 신청서 내용과 일치하는지 검수 및 포장을 합니다.<br><br>
								만약 배송 신청서 내용과 다르거나 비정상 상황일 경우 안심하세요.<br>
								즉시 회원님께 알림톡으로 안내드리며 상황을 공유합니다.
							</p>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img4_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img4.png" alt=""  class="img-responsive" >
							</div>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img5_2x.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img5.png" alt=""  class="img-responsive" >
							</div>
							
							<div class="btn-wrap">
								<div class="link-btn type-2" @click="onNav('/')">
									도착사진 보러가기 <i class="el-icon-top-right"></i>
								</div>
							</div>			
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							4. 배송비 결제
							<img loading="lazy" src="../../assets/icon/flag_ko.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								주문하신 상품이 모두 도착하면 알림톡 안내를 드립니다.
							</p>		
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img6.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img6_2x.png" alt=""  class="img-responsive" >
							</div>
							<p class="mb20">
								마이페이지에서 확인하신다음 배송요청을 해주시면 <br>
								포장 완료 후 회원님께 배송비 결제 안내 알림톡을 안내드립니다.<br>
								마이페이지에서 배송비 결제를 해주시면 한국으로 출발합니다.
							</p>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img7.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img7_2x.png" alt=""  class="img-responsive" >
							</div>			
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							5. 운송통관
							<img loading="lazy" src="../../assets/icon/ico_customs.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								회원님이 작성해주신 배송 신청서를 <br class="visible-lg">
								한/중국 세관에 제출하여 수출/입통관을 합니다.<br>
								중국세관에 수출 신고후 한국으로 국제운송이 시작됩니다.
							</p>
							<h6 class="img-title">○ 컨테이너 선적</h6>	
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img8.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img8_2x.png" alt=""  class="img-responsive" >
							</div>
							<h6 class="img-title">○ 항공/선박을 통한 국제 운송</h6>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img9.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img9_2x.png" alt=""  class="img-responsive" >
							</div>
							<h6 class="img-title">○ 한국 세관 도착 후 검사</h6>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img10.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img10_2x.png" alt=""  class="img-responsive" >
							</div>			
						</div>			
					</div>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8">
					<div class="type-card">
						<div class="card-head">
							6. 수령
							<img loading="lazy" src="../../assets/icon/ico_delivery.png" alt="" class="">
						</div>
						<div class="card-body">
							<p class="mb20">
								국내 통관 완료된 상품은 <br class="visible-lg">
								국내 배송하여 회원님께 전해드립니다.<br>
								직구에 성공하셨습니다. 축하합니다!
							</p>
						
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img11.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img11_2x.png" alt=""  class="img-responsive" >
							</div>
							<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img12.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img12_2x.png" alt=""  class="img-responsive" >
							</div>
						<!-- 	<div class="img-box mb20">
								<img loading="lazy" v-if="!isMobile" src="../../assets/list/document_start_img13.png" alt="" class="img-responsive" >
								<img loading="lazy" v-else src="../../assets/list/document_start_img13_2x.png" alt=""  class="img-responsive" >
							</div>	 -->
						</div>			
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="text-align: center;"  v-if="!isLoggedIn">
			<router-link to="/register" class="register-button">
				회원가입<i class="el-icon-arrow-right"></i>
			</router-link>
		</div>
		
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	//import { safePush } from '@/utils/router';
	import { mapGetters } from 'vuex';
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return{
				
			}
		},
		
		computed: {
		  isMobile() {
		    return window.innerWidth <= 768;
		  },
			// 映射 getters
			...mapGetters(['isLoggedIn']),
		},
		methods: {
			goCustomsinfoUrl(url){
				window.open(url, '_blank');
			},
			onNav(url){
				//safePush(this.$router, url);
				 const { href } = this.$router.resolve({ path: '/' });
				window.open(href, '_blank');
			},
			onCurrentNav(url){
				this.$router.push(url);
			}
			
		},
		
	}

</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 20px;
	    font-weight: bold;
	    color: rgb(247, 148, 29);
	    margin: 0 0 19px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
		color: #111;
	    margin: 0;
	}
	.title-wrap .summary{
		padding-top: 10px;
		color: #666;
	}
	
	.type-card{
		border: 1px solid var(--border-color);
		box-shadow: 8px 12px 12px rgba(0, 0, 0, 0.06);
		border-radius: 26px;
		overflow: hidden;
		margin:5px 10px 20px 10px;
	}
	.type-card .card-head{
		font-weight: 700;
		font-size: 20px;
		height: 66px;
		line-height: normal;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		gap: 0 8px;
		background: rgb(247, 148, 29);	
	}
	.type-card .card-body{
		padding: 10px 20px;
		background: #fff;
		height:850px; 
	}
	
	.type-card .card-body p{
		font-size: 14px;
		color: #111111;
		line-height: 1.8;
	}
	.type-card .divided-line {
	    border-top: 1px dashed var(--border-color);
	    margin: 26px 0;
	}
	.type-card .img-title{
		margin: 0 0 8px;
		font-weight: 700;
		font-size: 13px;
		line-height: 16px;
		color: #000000;
		position: relative;
		padding-left: 12px;
	}
	.mb20 {
	    margin-bottom: 20px !important;
	}
	.mb40-xs{
		height:150px;
	}
	.mb40-zsy{
		height:30px;
	}
	.type-card .btn-wrap{
		display: flex;
		gap: 0 9px;
		align-items: center;
		justify-content: center;
	}
	.link-btn{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		transition: 0.25s;
		line-height: normal;
	}
	.link-btn.type-1{
		color: #fff;
		background: var(--main-color);
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.register-button{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		min-width: 180px;
		margin-bottom: 40px;
		height: 64px;
		border: 1px solid var(--main-color);
		background: var(--main-color);
		border-radius: 36px;
		font-weight: 500;
		font-size: 17px;
		text-decoration: none !important;
		color: #fff !important;
		transition: 0.25s;
		cursor: pointer
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}	
	@media (max-width: 768px) {	
		
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			color: #0055D4;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		.type-card .card-body{
			padding: 26px;
			background: #fff;
			height:auto; 
		}
		.mb40-zsy{
			height:0;
		}
		
	}
</style>